<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      @for (owner of owners.controls; track owner; let index = $index) {
        <ng-container [formGroup]="owner">
          <div class="formControl mt">
            <pr-input-radio
              formControlName="hasChild"
              direction="column"
              [isDefault]="false"
              [toggle]="true"
              columns="6"
            >
            </pr-input-radio>
            @if (owner.get('hasChild')?.value) {
              <div class="row">
                <span class="col col-md-6 pr-input-label"
                  >Combien d'enfant(s) avez-vous ?
                </span>
              </div>
              <div class="row">
                <div class="col col-md-6">
                  <pr-select-form
                    formControlName="childrenCount"
                    [options]="childrenCountOptions"
                    [derrors]="derrors"
                  >
                  </pr-select-form>
                </div>
              </div>
              <ng-container formArrayName="householdChildren">
                @for (
                  child of householdChildren($any(owner)).controls;
                  track child;
                  let i = $index
                ) {
                  <pr-funnel-persons
                    [index]="i"
                    [derrors]="derrors"
                    type="child"
                    [formGroup]="$any(child)"
                    (remove)="onRemove($any(owner), i)"
                  >
                  </pr-funnel-persons>
                }
              </ng-container>
            }
          </div>
        </ng-container>
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
